/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  name: z.string(),
  login_id: z.string(),
  password: z.string(),
  salt: z.string(),
  group_id: z.string().uuid(),
  authority: z.number(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const UserBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type UserBase = z.infer<typeof base>;
export type UserBasePutPayload = z.infer<typeof put>;
export type UserBasePatchPayload = z.infer<typeof patch>;
export type UserBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type UserBaseCreateAttributes = z.infer<typeof create>;
export type UserBaseUpdateAttributes = z.infer<typeof update>;
export type UserBaseCacheAttributes = z.infer<typeof cache>;
export type UserBaseCachesAttributes = z.infer<typeof caches>;